import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";
import React from "react";

import { HeaderSectionV2Props, ProductHeaderSection } from "./ProductHeaderSection";
import { Wrapper, TitleWrapper, PriceAndAvailability } from "./ProductHeaderV2LayoutComponents";

const LabelListSkeleton = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.airiness,
    alignItems: "center",
}));

const AvailabilityButtonSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.roundness,
}));

export const ProductHeaderV2Skeleton = React.forwardRef(function HeaderSectionV2Component(
    props: Omit<HeaderSectionV2Props, "ContentComponent" | "title">,
    forwardedRef
) {
    const { withStickyAppBar, showHeader } = props;
    return (
        <ProductHeaderSection
            title=""
            showHeader={showHeader}
            withStickyAppBar={withStickyAppBar}
            ContentComponent={ContentSkeleton}
            ref={forwardedRef}
            productRatingComponent={null}
        />
    );
});

const ContentSkeleton = () => {
    return (
        <Wrapper>
            <TitleWrapper>
                <Skeleton variant="rectangular" width="70%" height={45} />
                <LabelListSkeleton>
                    <Skeleton variant="rectangular" width="10%" height={20} />
                    <Skeleton variant="rectangular" width="15%" height={20} />
                </LabelListSkeleton>
            </TitleWrapper>
            <PriceAndAvailability>
                <AvailabilityButtonSkeleton variant="rounded" width={170} height={40} />
            </PriceAndAvailability>
        </Wrapper>
    );
};
